<!-- Navigation Tabs -->
<div class="flex items-center gap-1 bg-white rounded-xl shadow-sm mx-6 mt-6 p-1.5">
  <a routerLink="/dashboard/clasesPracticas/cuadrante"
    [class]="isActive('/cuadrante') ? 'flex items-center gap-2 px-5 py-2.5 bg-red-600 text-white rounded-lg font-medium text-sm transition-all shadow-sm' : 'flex items-center gap-2 px-5 py-2.5 text-gray-600 rounded-lg font-medium text-sm hover:bg-gray-50 hover:text-red-600 transition-all'">
    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16M4 18h16"></path>
    </svg>
    Cuadrante
  </a>
  <a routerLink="/dashboard/clasesPracticas/calendario"
    [class]="isActive('/calendario') ? 'flex items-center gap-2 px-5 py-2.5 bg-red-600 text-white rounded-lg font-medium text-sm transition-all shadow-sm' : 'flex items-center gap-2 px-5 py-2.5 text-gray-600 rounded-lg font-medium text-sm hover:bg-gray-50 hover:text-red-600 transition-all'">
    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
    </svg>
    Calendario
  </a>
  <a routerLink="/dashboard/clasesPracticas/generador"
    [class]="isActive('/generador') ? 'flex items-center gap-2 px-5 py-2.5 bg-red-600 text-white rounded-lg font-medium text-sm transition-all shadow-sm' : 'flex items-center gap-2 px-5 py-2.5 text-gray-600 rounded-lg font-medium text-sm hover:bg-gray-50 hover:text-red-600 transition-all'">
    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
    </svg>
    Generador
  </a>
  <a routerLink="/dashboard/clasesPracticas/gestionMasiva"
    [class]="isActive('/gestionMasiva') ? 'flex items-center gap-2 px-5 py-2.5 bg-red-600 text-white rounded-lg font-medium text-sm transition-all shadow-sm' : 'flex items-center gap-2 px-5 py-2.5 text-gray-600 rounded-lg font-medium text-sm hover:bg-gray-50 hover:text-red-600 transition-all'">
    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"></path>
    </svg>
    Gestión
  </a>
</div>

<router-outlet></router-outlet>
